/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-lines */
/* eslint-disable complexity */
/* eslint-disable no-shadow */
import {IProperty, IPropertyValue} from 'modules/products/types';
import {SECTION_CODE} from 'modules/product-card/constants';
import {IProduct} from 'modules/product-card/models/ProductResponse';
import {getProductBrand, getProductCanonSection, getProductSpecialCategory} from 'modules/product-card/helpers';
import {
    AGE_EXTRACT,
    AGING_CATEGORY,
    AGING_TANK,
    APPELLATION,
    BARRELL,
    BRAND,
    CLASS,
    COLOR,
    COUNTRY,
    DECANTATION,
    DRINK_CATEGORY,
    DRINK_TYPE,
    GLASS_DIAMETER,
    GLASS_HEIGHT,
    GRAPE_CONTENT,
    MANUFACTURER,
    MATERIAL,
    NET_VOLUME,
    PREMIUM_PACK,
    PRODUCT_TYPE,
    PRODUCTION_METHOD_HB,
    RAW,
    REGION,
    RICE_AFTER_POLISHING,
    STORAGE_CAPACITY,
    STRONGNESS,
    SUGAR_TYPE,
    SUITABLE,
    TEMPERATURE_FROM,
    TEMPERATURE_TO,
    YEAR,
} from 'modules/product-card/constants/characteristics';
import {ICharacteristicItem, TCharacteristicList} from 'modules/product-card/types';
import {VINO_CHARACTERISTICS} from 'modules/product-card/constants/characteristics/vino';
import {SHAMPANSKOE_CHARACTERISTICS} from 'modules/product-card/constants/characteristics/shampanskoe';
import {SAKE_CHARACTERISTICS} from 'modules/product-card/constants/characteristics/sake';
import {VISKY_CHARACTERISTICS} from 'modules/product-card/constants/characteristics/visky';
import {ARMANYAK_CHARACTERISTICS, KONYAK_CHARACTERISTICS} from 'modules/product-card/constants/characteristics/konyak';
import {
    GRAPPA_AKVAVIT_CHARACTERISTICS,
    KALVADOS_CHARACTERISTICS,
    KSN_CHARACTERISTICS,
    VODKA_CHARACTERISTICS,
} from 'modules/product-card/constants/characteristics/ksn';
import {SOK_CHARACTERISTICS, VODA_CHARACTERISTICS} from 'modules/product-card/constants/characteristics/voda_i_soki';
import {FINE_AND_RARE_CHARACTERISTICS} from 'modules/product-card/constants/characteristics/fineAndRare';
import {STEKLO_CHARACTERISTICS} from 'modules/product-card/constants/characteristics/steklo';
import {AKSESSUARY_CHARACTERISTICS} from 'modules/product-card/constants/characteristics/aksessuary';

export type TCharacteristicType = 'HEADER' | 'DETAILED' | 'TABLET';

export const CHARACTERISTICS_MAP: Record<string, Record<TCharacteristicType, TCharacteristicList>> = {
    [SECTION_CODE.VINO]: VINO_CHARACTERISTICS,

    [SECTION_CODE.IGRISTOE_VINO]: SHAMPANSKOE_CHARACTERISTICS,
    [SECTION_CODE.SHAMPANSKOE]: SHAMPANSKOE_CHARACTERISTICS,

    [SECTION_CODE.SAKE]: SAKE_CHARACTERISTICS,

    [SECTION_CODE.VISKY]: VISKY_CHARACTERISTICS,
    [SECTION_CODE.KONYAK]: KONYAK_CHARACTERISTICS,
    [SECTION_CODE.VODKA]: VODKA_CHARACTERISTICS,
    [SECTION_CODE.SOK]: SOK_CHARACTERISTICS,

    [SECTION_CODE.KSN]: KSN_CHARACTERISTICS,
    [SECTION_CODE.VODKA]: VODKA_CHARACTERISTICS,

    [SECTION_CODE.ARMANYAK]: ARMANYAK_CHARACTERISTICS,

    [SECTION_CODE.GRAPPA]: GRAPPA_AKVAVIT_CHARACTERISTICS,
    [SECTION_CODE.AKVAVIT]: GRAPPA_AKVAVIT_CHARACTERISTICS,
    // кальвадос имеет такой же набор как и для граппы/аквавита
    [SECTION_CODE.KALVADOS]: KALVADOS_CHARACTERISTICS,

    [SECTION_CODE.MINERALNAYA_VODA]: VODA_CHARACTERISTICS,
    [SECTION_CODE.VODA_I_SOKI]: VODA_CHARACTERISTICS,

    [SECTION_CODE.FINE_AND_RARE]: FINE_AND_RARE_CHARACTERISTICS,

    [SECTION_CODE.STEKLO]: STEKLO_CHARACTERISTICS,
    [SECTION_CODE.BOKALY]: STEKLO_CHARACTERISTICS,

    [SECTION_CODE.AKSESSUARY]: AKSESSUARY_CHARACTERISTICS,
};

export const DEFAULT_CHARACTERISTICS: Record<TCharacteristicType, any> = KSN_CHARACTERISTICS;

interface ISetResultCharacteristicOptions {
    divide?: number;
    isRange?: boolean;
    noLink?: boolean;
    noZeroValue?: boolean;
    unit?: string;
}

interface IGetValueOptions {
    divide?: number;
    unit?: string;
}

export interface IResultCharacteristicDataList {
    link?: string;
    text: string;
}

export interface IResultCharacteristicData {
    code: ICharacteristicItem;
    dataList: IResultCharacteristicDataList[];
    titleList: string[];
}

const {AKSESSUARY, KONYAK, KSN, VISKY} = SECTION_CODE;

export const BRANDED_CATEGORIES = [KONYAK, KSN, VISKY];

// Подробнее
// https://conf.awg.ru/pages/viewpage.action?pageId=194846045#UC46%D0%9F%D1%80%D0%BE%D1%81%D0%BC%D0%BE%D1%82%D1%80%D0%BE%D1%81%D0%BD%D0%BE%D0%B2%D0%BD%D0%BE%D0%B9%D0%B8%D0%BD%D1%84%D0%BE%D1%80%D0%BC%D0%B0%D1%86%D0%B8%D0%B8%D0%BE%D1%82%D0%BE%D0%B2%D0%B0%D1%80%D0%B5-FR-4
// и
// https://conf.awg.ru/pages/viewpage.action?pageId=184135510#id-%D0%9C%D0%BE%D0%B4%D0%B5%D0%BB%D1%8CProduct(BFFAPI)-Property%D0%9E%D0%B1%D1%8A%D0%B5%D0%BA%D1%82Property
// https://kb.simple.ru/pages/viewpage.action?pageId=129238164

// eslint-disable-next-line max-lines-per-function,max-params
export function getProductCharacteristics(
    product: IProduct,
    type: TCharacteristicType,
    productProperties: IProperty[] = product.properties,
    topSection: string = product.topSection,
    productCategory: string = getProductSpecialCategory(product),
    linkRoot: string = `/catalog/${product.topSection}/filter/`,
): IResultCharacteristicData[] {
    const foundCharacteristics: IProperty[] = [];
    let list: TCharacteristicList = [];
    const resultCharacteristicsList: IResultCharacteristicData[] = [];

    const checkIsValueSuitable = (value: any, noZeroValue: boolean = false): boolean => {
        if (noZeroValue && 0 === value) {
            return false;
        }
        return null !== value && value !== undefined && '' !== value;
    };

    const getFromFoundCharacteristics = (code: string): IProperty | undefined => {
        return foundCharacteristics.find(({code: propCode}) => propCode === code);
    };

    const getFromList = (key: string): ICharacteristicItem | undefined => {
        return list.find(({KEY}) => KEY === key);
    };

    const getLink = (code?: string, value?: string | number, isRange: boolean = false): string => {
        if (!code || !value) {
            return '';
        }
        return isRange ? `${linkRoot}${code}-from-${value}-to-${value}` : `${linkRoot}${code}-${value}`;
    };

    const getValue = (value: string | number, options: IGetValueOptions = {}): string => {
        const {divide, unit = ''} = options;
        const numericValue = Number(value);
        if (divide && !isNaN(numericValue)) {
            return `${numericValue / divide}${unit}`;
        }
        return `${value}${unit}`;
    };

    const setFoundCharacteristics = (): void => {
        list.forEach((codeData) => {
            const property = productProperties.find(({code}) => code === codeData.KEY);
            if (property) {
                foundCharacteristics.push(property);
            }
        });
    };

    const setList = (type: TCharacteristicType): void => {
        const canonSection = getProductCanonSection(product.sections ?? []);
        if (canonSection.code && canonSection.code !== productCategory) {
            list =
                CHARACTERISTICS_MAP[canonSection.code]?.[type] ||
                CHARACTERISTICS_MAP[productCategory]?.[type] ||
                DEFAULT_CHARACTERISTICS[type];
        } else {
            list = CHARACTERISTICS_MAP[productCategory]?.[type] ?? DEFAULT_CHARACTERISTICS[type];
        }
    };

    const setResultCharacteristic = (
        code: ICharacteristicItem,
        options: ISetResultCharacteristicOptions = {},
    ): void => {
        const property = getFromFoundCharacteristics(code.KEY);
        if (!property || null === property.value) {
            return;
        }
        if (Array.isArray(property.value)) {
            return;
        }
        if ('object' === typeof property.value && 'value' in property.value) {
            const valueData = property.value as IPropertyValue;
            if (!checkIsValueSuitable(valueData.value, options.noZeroValue)) {
                return;
            }
            const {isRange, unit} = options;
            const {slug, value} = valueData;
            resultCharacteristicsList.push({
                code,
                dataList: [
                    {
                        link: getLink(code.FILTER_CODE, slug, isRange),
                        text: getValue(value, {unit}),
                    },
                ],
                titleList: [property.title],
            });
        } else {
            if (!checkIsValueSuitable(property.value, options.noZeroValue)) {
                return;
            }
            const {isRange, unit} = options;
            resultCharacteristicsList.push({
                code,
                dataList: [
                    {
                        link: getLink(code.FILTER_CODE, property.value as string | number, isRange),
                        text: getValue(property.value as string | number, {unit}),
                    },
                ],
                titleList: [property.title],
            });
        }
    };

    const setResultCharacteristicWithPrimitiveValue = (
        code: ICharacteristicItem,
        options: ISetResultCharacteristicOptions = {},
    ): void => {
        const property = getFromFoundCharacteristics(code.KEY);
        if (!property) {
            return;
        }
        const value = Number(property.value);
        if (!checkIsValueSuitable(value, options.noZeroValue)) {
            return;
        }
        const {divide, isRange, noLink, unit} = options;
        const link = noLink ? '' : getLink(code.FILTER_CODE, value, isRange);
        resultCharacteristicsList.push({
            code,
            dataList: [
                {
                    link,
                    text: getValue(value, {divide, unit}),
                },
            ],
            titleList: [property.title],
        });
    };

    const setResultCharacteristicManufacturer = (): void => {
        const property = getFromList(MANUFACTURER.KEY);
        if (!property) {
            return;
        }
        const manufacturer = product.properties.find(({code}) => code === MANUFACTURER.KEY)?.value as IPropertyValue;
        if (!manufacturer) {
            return;
        }
        resultCharacteristicsList.push({
            code: MANUFACTURER,
            dataList: [
                {
                    link: getLink(MANUFACTURER.FILTER_CODE, manufacturer.slug),
                    text: String(manufacturer.translate ?? manufacturer.value),
                },
            ],
            titleList: ['Производитель'],
        });
    };

    const setResultCharacteristicBrand = (): void => {
        const property = getFromList(BRAND.KEY);

        if (!property) {
            return;
        }

        const brandFromProperties = product.properties.find(({code}) => code === BRAND.KEY)?.value as IPropertyValue;

        if (!brandFromProperties) {
            return;
        }

        const text = product.brand?.title ?? brandFromProperties.translate;

        if (!text) {
            return;
        }

        resultCharacteristicsList.push({
            code: BRAND,
            dataList: [
                {
                    link: getLink(BRAND.FILTER_CODE, brandFromProperties.slug),
                    text,
                },
            ],
            titleList: ['Бренд'],
        });
    };

    const setResultCharacteristicCountryRegion = (): void => {
        const countryProperty = getFromFoundCharacteristics(COUNTRY.KEY);
        const regionProperty = getFromFoundCharacteristics(REGION.KEY);
        if (!countryProperty && !regionProperty) {
            return;
        }

        // https://kb.simple.ru/pages/viewpage.action?pageId=129239497
        // пункт 12 (*Страна для категории Бокалы НЕ отображается только у бренда Spiegelau, если "Страна" НЕ "Германия".)
        if (
            productCategory === SECTION_CODE.STEKLO &&
            'spiegelau' === getProductBrand(product)?.toLowerCase() &&
            'гер' !== (countryProperty?.value as IPropertyValue)?.id?.toLowerCase()
        ) {
            return;
        }

        const data: Partial<IResultCharacteristicData> = {};

        if (countryProperty) {
            const valueData = countryProperty.value as IPropertyValue;
            if (checkIsValueSuitable(valueData.value)) {
                data.code = COUNTRY;
                data.dataList = [
                    {
                        link: getLink(COUNTRY.FILTER_CODE, valueData.slug),
                        text: String(valueData.value),
                    },
                ];
                data.titleList = [countryProperty.title];
            }
        }
        if (regionProperty) {
            const valueData = regionProperty.value as IPropertyValue;
            if (checkIsValueSuitable(valueData.value)) {
                const item = {
                    link: getLink(REGION.FILTER_CODE, valueData.slug),
                    text: valueData.value,
                };
                if (data.dataList) {
                    data.dataList.push(item);
                    data.titleList?.push(regionProperty.title.toLowerCase());
                } else {
                    data.code = REGION;
                    data.dataList = [item];
                    data.titleList = [regionProperty.title.toLowerCase()];
                }
            }
        }
        if (data.code && data.dataList && data.titleList) {
            resultCharacteristicsList.push(data as IResultCharacteristicData);
        }
    };

    const setResultCharacteristicGrapeContent = (): void => {
        const property = getFromFoundCharacteristics(GRAPE_CONTENT.KEY);
        if (
            !property?.value ||
            (Array.isArray(property.value) &&
                (0 === property.value.length || property.value.every((value) => !checkIsValueSuitable(value))))
        ) {
            return;
        }
        resultCharacteristicsList.push({
            code: GRAPE_CONTENT,
            dataList: (property.value as IPropertyValue[]).map(({grape, slug, value}) => ({
                link: getLink(GRAPE_CONTENT.FILTER_CODE, slug),
                text: value && 0 < Number(value) ? `${grape} ${value}%` : `${grape}`,
            })),
            titleList: [property.title],
        });
    };

    const setResultCharacteristicPremiumPack = (): void => {
        const property = getFromFoundCharacteristics(PREMIUM_PACK.KEY);
        if (!property?.value) {
            return;
        }
        resultCharacteristicsList.push({
            code: PREMIUM_PACK,
            dataList: [{text: 'Да'}],
            titleList: ['Подарочная упаковка'],
        });
    };

    const setResultCharacteristicTemperature = (): void => {
        if (topSection === AKSESSUARY) {
            return;
        }
        const propertyTemperatureFrom = getFromFoundCharacteristics(TEMPERATURE_FROM.KEY);
        const propertyTemperatureTo = getFromFoundCharacteristics(TEMPERATURE_TO.KEY);

        const rawFrom = propertyTemperatureFrom?.value as number | undefined;
        const rawTo = propertyTemperatureTo?.value as number | undefined;

        const hasFrom = checkIsValueSuitable(rawFrom);
        const hasTo = checkIsValueSuitable(rawTo);

        if (!hasFrom && !hasTo) {
            return;
        }

        const valueFrom = hasFrom ? (rawFrom as number) : undefined;
        const valueTo = hasTo ? (rawTo as number) : undefined;

        let resultValue: string;
        if (valueFrom !== undefined && valueTo !== undefined && valueFrom !== valueTo) {
            resultValue = `${valueFrom}-${valueTo}°C`;
        } else if (valueFrom !== undefined) {
            resultValue = `${valueFrom}°C`;
        } else {
            resultValue = `${valueTo}°C`;
        }

        resultCharacteristicsList.push({
            code: TEMPERATURE_FROM,
            dataList: [
                {
                    text: resultValue,
                },
            ],
            titleList: ['Температура подачи'],
        });
    };

    const setResultCharacteristicVolume = (): void => {
        const property = getFromFoundCharacteristics(NET_VOLUME.KEY);
        if (!property?.value) {
            return;
        }
        const value = Number(property.value);
        if (!checkIsValueSuitable(value, true)) {
            return;
        }
        const filterValue = String(value).replace('.', '_');
        resultCharacteristicsList.push({
            code: NET_VOLUME,
            dataList: [
                {
                    link: getLink(NET_VOLUME.FILTER_CODE, filterValue),
                    text: `${value} л`,
                },
            ],
            titleList: [property.title],
        });
    };

    const setResultCharacteristicsList = (type: TCharacteristicType): void => {
        if ('DETAILED' === type) {
            setResultCharacteristic(REGION);
        } else {
            setResultCharacteristicCountryRegion();
        }
        setResultCharacteristic(COLOR);
        if (BRANDED_CATEGORIES.includes(productCategory)) {
            setResultCharacteristicBrand();
        } else {
            setResultCharacteristicManufacturer();
        }
        setResultCharacteristic(SUGAR_TYPE);
        setResultCharacteristic(SUITABLE);
        setResultCharacteristic(BARRELL);
        setResultCharacteristic(AGING_CATEGORY);
        setResultCharacteristic(PRODUCT_TYPE);
        setResultCharacteristic(DRINK_TYPE);
        setResultCharacteristic(APPELLATION);
        setResultCharacteristic(CLASS);
        setResultCharacteristic(RAW);
        setResultCharacteristic(MATERIAL);
        setResultCharacteristic(PRODUCTION_METHOD_HB);
        setResultCharacteristic(DRINK_CATEGORY);
        setResultCharacteristic(DECANTATION);
        setResultCharacteristic(AGING_TANK);
        setResultCharacteristic(AGE_EXTRACT, {
            noZeroValue: true,
            unit: ' лет',
        });
        setResultCharacteristic(STORAGE_CAPACITY, {
            noLink: true,
            noZeroValue: true,
        });
        setResultCharacteristicWithPrimitiveValue(YEAR, {
            isRange: true,
            noZeroValue: true,
        });
        setResultCharacteristicWithPrimitiveValue(STRONGNESS, {
            isRange: true,
            noZeroValue: true,
            unit: '%',
        });
        setResultCharacteristicWithPrimitiveValue(RICE_AFTER_POLISHING, {
            noLink: true,
            unit: '%',
        });
        setResultCharacteristicWithPrimitiveValue(GLASS_HEIGHT, {
            divide: 10,
            noLink: true,
            noZeroValue: true,
            unit: ' см',
        });
        setResultCharacteristicWithPrimitiveValue(GLASS_DIAMETER, {
            divide: 10,
            noLink: true,
            noZeroValue: true,
            unit: ' см',
        });
        setResultCharacteristicGrapeContent();
        setResultCharacteristicPremiumPack();
        setResultCharacteristicTemperature();
        setResultCharacteristicVolume();
    };

    const sortResultCharacteristicsList = (): void => {
        resultCharacteristicsList.sort((a, b) => list.indexOf(a.code) - list.indexOf(b.code));
    };

    try {
        setList(type);
        setFoundCharacteristics();
        setResultCharacteristicsList(type);
        sortResultCharacteristicsList();
        return [...resultCharacteristicsList];
    } catch (error) {
        console.error('Ошибка формирования списка характеристик товара:', error);
        return [];
    }
}
